import axios, {
  InternalAxiosRequestConfig,
  AxiosResponse,
  AxiosError,
} from "axios";
import pinia from "@/plugins/piniaStore";
import { urls } from "@/stores/urls";
import { userTokenStore } from "@/stores/tokenStore";
//import { sessionEndPage } from "@/globals/helpers/sessionLogout";
// A camada HTTP não navega: avisa quem se registar.
type SessionExpiredHandler = () => void;
let onSessionExpired: SessionExpiredHandler | null = null;

export function setSessionExpiredHandler(fn: SessionExpiredHandler) {
  onSessionExpired = fn;
}

const url = urls(pinia);
const token = userTokenStore(pinia);

export const instance = axios.create({
  baseURL: url.baseURL,
  //timeout: 120000,
});

//--------------------------
instance.interceptors.request.use(successfulRequest, failedRequest);
instance.interceptors.response.use(successfulResponse, failedResponse);

function successfulRequest(
  config: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig {
  if (token.access) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${token.access}`;
  }
  console.log("Request:", config.method, config.url);
  return config;
}

function successfulResponse(response: AxiosResponse): AxiosResponse {
  return response;
}

//-----------------------------------------

function failedRequest(error: AxiosError): Promise<never> {
  console.log("BACKEND ERROR", error);
  return Promise.reject(error);
}

// failResponse replaced by jirodrig 15.3.2026
// function failedResponse(error: AxiosError): AxiosResponse | undefined {
//   console.log("NETWORK ERROR - Interceptor-failedResponse", error.code);
//   return error.response;
// }

/* jirodrig 22.set.2026
async function failedResponse(error: AxiosError): Promise<any> {
  const originalRequest = error.config as InternalAxiosRequestConfig & {
    _retry?: boolean;
  };

  if (error.response?.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;

    try {
      // Attempt to refresh token
      const refreshResponse = await axios.post<{ access: string }>(
        `${url.baseURL}refresh-token/`,
        {
          refresh: token.refresh,
        },
      );

      // Success → update access token
      token.access = refreshResponse.data.access;
      originalRequest.headers = originalRequest.headers || {};
      originalRequest.headers["Authorization"] = `Bearer ${token.access}`;
      sessionEndPage();
      return instance(originalRequest); // retry original request
    } catch (refreshError) {
      return Promise.resolve(error.response);
    }
  }

  // Other errors
  console.log("AXIOS-ERROR-RESPONSE", error, error.response);
  return Promise.resolve(error.response);
} */

//-------------------

let refreshing: Promise<string> | null = null;

function refreshAccess(): Promise<string> {
  // Um único refresh em curso, partilhado por todos os pedidos que falharem.
  refreshing ??= axios
    .post<{ access: string }>(`${url.baseURL}refresh-token/`, {
      refresh: token.refresh,
    })
    .then((r) => r.data.access)
    .finally(() => {
      refreshing = null;
    });
  return refreshing;
}

async function failedResponse(error: AxiosError): Promise<any> {
  const original = error.config as InternalAxiosRequestConfig & {
    _retry?: boolean;
  };
  const isAuthEndpoint = /\/(login|refresh-token)\/?$/.test(
    original?.url ?? "",
  );

  if (
    error.response?.status === 401 &&
    original &&
    !original._retry &&
    !isAuthEndpoint &&
    !!token.refresh
  ) {
    original._retry = true;
    try {
      token.access = await refreshAccess();
      original.headers = original.headers || {};
      original.headers["Authorization"] = `Bearer ${token.access}`;
      return instance(original); // renovação silenciosa
    } catch {
      token.clearToken("");
      //sessionEndPage(); // só aqui a sessão terminou
      onSessionExpired?.();
      return Promise.resolve(error.response);
    }
  }

  console.log("AXIOS-ERROR-RESPONSE", error.code, error.response?.status);
  return Promise.resolve(error.response);
}

export default instance;
